import { handleActions } from "redux-actions";
import { PAGE_PRODUCTS, PRODUCTS, SCOPE_BRAND_SET } from "constants/action-types";

export interface INamespace {
    error?: Error;
    isFetching: boolean;
    results: string[];
    cacheKey: string;
    nextPage?: string;
    hasMoreResults: boolean;
}

export interface IState {
    collections: {
        [namespace: string]: INamespace;
    };
}

export const initialState: IState = {
    collections: {},
};

export const getDefaultReducerState = (cacheKey?) => ({
    cacheKey,
    results: [],
    refresh: false,
    isFetching: true,
    hasMoreResults: false,
    nextPage: undefined,
});

const startFetchProducts = (state: IState, { meta }: any) => {
    if (meta.cacheKey && state.collections[meta.key] && state.collections[meta.key].cacheKey === meta.cacheKey) {
        return state;
    }
    if (meta.nextPage) {
        return {
            ...state,
            collections: {
                ...state.collections,
                [meta.key]: {
                    ...state.collections[meta.key],
                    refresh: false,
                    isFetching: true,
                    hasMoreResults: false,
                    nextPage: undefined,
                },
            },
        };
    }
    return {
        ...state,
        collections: {
            ...state.collections,
            [meta.key]: getDefaultReducerState(meta.cacheKey),
        },
    };
};

export const productsReducer = handleActions<IState, any>(
    {
        [SCOPE_BRAND_SET]: () => {
            return initialState;
        },
        [PRODUCTS.FETCH.START]: startFetchProducts,
        [PAGE_PRODUCTS.FETCH.START]: startFetchProducts,
        [PRODUCTS.FETCH.RESET]: (state: IState, { error, meta, payload }: any) => {
            const newState: any = {
                refresh: true,
                results: [],
                isFetching: false,
                hasMoreResults: false,
                nextPage: undefined,
            };

            return {
                ...state,
                collections: {
                    ...state.collections,
                    [meta.key]: newState,
                },
            };
        },

        [PRODUCTS.FETCH.COMPLETED]: (state: IState, { error, meta, payload }: any) => {
            const current = state.collections[meta.key];
            if (error) {
                return {
                    ...state,
                    collections: {
                        ...state.collections,
                        [meta.key]: {
                            ...current,
                            error: payload,
                            isFetching: false,
                            hasMoreResults: false,
                            nextPage: undefined,
                        },
                    },
                };
            }
            return {
                ...state,
                collections: {
                    ...state.collections,
                    [meta.key]: {
                        ...current,
                        results: meta.replace ? payload.results : (current?.results ?? []).concat(payload.results),
                        nextPage: payload.nextPage,
                        hasMoreResults: !!payload.nextPage,
                        isFetching: false,
                    },
                },
            };
        },
    },
    initialState
);
